package one.healthium.profile.navigation.profile

import com.arkivanov.decompose.ComponentContext

class DefaultProfileComponent(
    componentContext: ComponentContext,
    private val onSettingsClicked: () -> Unit,
    private val onWeightProgressClicked: () -> Unit,
    private val onCaloriesProgressClicked: () -> Unit,
    private val onHealthKitClicked: () -> Unit,
) : ProfileComponent, ComponentContext by componentContext {
    override fun onSettingsClicked() {
        onSettingsClicked.invoke()
    }

    override fun onWeightProgressClicked() {
        onWeightProgressClicked.invoke()
    }

    override fun onCaloriesProgressClicked() {
        onCaloriesProgressClicked.invoke()
    }

    override fun onHealthKitClicked() {
        onHealthKitClicked.invoke()
    }
}